module.exports = __webpack_public_path__ + "img/img02.89d6bc8d.png";